export const BRANCH_NODE_TYPES = [
  "data",
  "predictor",
  "design",
  "candidate",
] as const;
export type BranchNodeType = (typeof BRANCH_NODE_TYPES)[number];
